import { createChartSlide, createScatterChartSlide } from '../helpers/chart_slide';
import { createImageSlide } from '../helpers/image_slide';
import { createTableSlide } from '../helpers/table_slide';

const NATIVE_CHART_TYPES = new Set([
  'bar-chart',
  'bar-chart-two-labels',
  'bar-stack-chart',
  'column-chart',
]);

const IMAGE_CHART_TYPES = new Set(['brand-tree-v2', 'chart-image']);

/**
 * Renders one legacy Narrative topic. Returns false when the item does not use a Narrative type so
 * the caller can delegate to the legacy chart/table path.
 *
 * @param {Object} options
 * @param {Object} options.item
 * @param {Object} options.itemProps
 * @returns {Promise<Boolean>}
 */
export const renderLegacyNarrativeItem = async ({ item, itemProps }) => {
  if (NATIVE_CHART_TYPES.has(item?.type)) {
    item.content?.map((chart) =>
      createChartSlide({
        chart: chart.data,
        readAs: chart.readAs,
        ...itemProps,
      })
    );
    return true;
  }

  if (IMAGE_CHART_TYPES.has(item?.type)) {
    await Promise.all(
      item.content?.map((chart) =>
        createImageSlide({
          chart: chart.data,
          readAs: chart.readAs,
          ...itemProps,
        })
      )
    );
    return true;
  }

  if (item?.type === 'scatter-chart') {
    item.content?.map((chart) =>
      createScatterChartSlide({
        chart: chart.data,
        readAs: chart.readAs,
        ...itemProps,
      })
    );
    return true;
  }

  if (item?.type === 'table') {
    item.content?.map((table) =>
      createTableSlide({
        ...itemProps,
        readAs: table.readAs,
        table: table.data,
      })
    );
    return true;
  }

  return false;
};
